/**
 * Created by claude on 22.07.26.
 * Shared base scene component extracted from TileGameScene
 */

class TileGameSceneComponent extends ScriptComponent {
    hasPagination() {
        return Game.currentGame.pagination.getTotal() > 1;
    }

    buildPaginationView() {
        this.paginationView = new PaginationView(Game.currentGame.pagination);
        return this.paginationView;
    }

    buildCardTableView() {
        this.cardTableView = new CardTableView(Game.currentGame.table);
        return this.cardTableView;
    }

    hasLightningRushMission() {
        return Boolean(Game.currentGame.lightingRushMission);
    }

    buildLightningRushMarks() {
        this.lightningRushMarksView = new LightningRushMarksView();
        return this.lightningRushMarksView;
    }

    onReady() {
        if (this.paginationView) {
            this.paginationControl = this.paginationView.getParent();
        }

        if (this.lightningRushMarksView) {
            this.lightningRushMarksControl = this.lightningRushMarksView.getParent();
        }

        Game.currentGame.pagination.on("changePage", this.animateNextPage.bind(this));
    }

    animateNextPage() {
        const position = this.cardTableView.getPosition();
        this.cardTableView.x -= cleverapps.resolution.getSceneSize().width;
        this.cardTableView.runAction(
            new cc.Sequence(
                cleverapps.effects.fireAction("tile3.next_screen"),
                new cc.MoveTo(0.7, position).easing(cc.easeBackOut())
            )
        );
    }

    getOverlappingNodes() {
        const scene = this.node;
        let overlappingNodes = [ComponentUtils.findComponentByName(scene, "UpMenuController").node, ComponentUtils.findChildByName(scene, "toolbar"), this.paginationControl];

        if (this.leaf && this.leaf.getOverlappingNodes) {
            overlappingNodes = overlappingNodes.concat(this.leaf.getOverlappingNodes());
        }

        const sideBar = ComponentUtils.findComponentByName(scene, "SideBarController");

        if (sideBar) {
            overlappingNodes = overlappingNodes.concat(sideBar.slots.map((slot) => slot.node));
        }

        return overlappingNodes.filter(Boolean);
    }

    onResize() {
        this.cardTableView && this.cardTableView.parent && this.cardTableView.setTableScale();
    }
}

Prefab.registerComponent("TileGameSceneComponent", TileGameSceneComponent);
